import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';

import './index.scss';

import { Pagination } from '@mui/material';

import { useFetching } from '../../hooks/useFetching';
import { getPageCount } from '../../utils/pages';
import AskQuotation from '../../components/statefull/AskQuotation';
import { getData } from '../../helpers/postData';
import setErrorHandler from '../../helpers/setErrorHandler';
import MarketplaceResource from '../../helpers/marketplaceResource';
import { productsDescription } from '../../constants/productsDescription';
import Icon from '../../components/stateless/Icon';
import { ProductsListSetup } from '../../constants';

const { REACT_APP_IMAGE_URL } = process.env;

const MarketplaceSinglePage = () => {

    let { templateId } = useParams();
    let history = useHistory();

    const [template, setTemplate] = useState(null);
    const [modalToggle, setModalToggle] = useState(false);
    const [modalProducts, setModalProducts] = useState(false);
    const [similar, setSimilar] = useState(null);
    const [products, setProducts] = useState(null);
    const [productsAll, setProductsAll] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const [initialProducts, setInitialProducts] = useState(null);
    const [formFields, setFormFields] = useState([]);
    const [reset, setReset] = useState(false);
    const [showV2, setShowV2] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [templateIdFetching, setTemplateIdFetching] = useState(templateId);
    const [successModal, setSuccessModal] = useState(false);


    const getMultipleRandom = (arr = [], num, templateId) =>  {
        const shuffled = [...arr].sort(() => 0.5 - Math.random());
        const id  = shuffled.findIndex(item => item.id === +templateId);

        shuffled.splice(id, 1);

        return shuffled.slice(0, num);
    }

    const [fetchTemplateAll] = useFetching(async () => {
        const temp = MarketplaceResource.getAll('/marketplaces');
        temp.then(res => {
            setSimilar(getMultipleRandom(res.data?.data, 3, templateIdFetching));
        });
    });

    const [fetchProducts] = useFetching(async () => {
        const products = MarketplaceResource.getProducts('/marketplace-products');
        const response = MarketplaceResource.getById('/marketplaces', templateIdFetching);
        let prod = [];
        let responseProducts = [];
        response.then(responseTemplate => {
            setTemplate(responseTemplate.data);
            if (products) {
                if (responseTemplate.data?.products.length > 0) {
                    products.then(res => {
                        console.log(res);
                        for (let p = 0; p <= ProductsListSetup.length; p++) {
                            if (ProductsListSetup[p]?.slug) {
                                res.find(o => {
                                    if (o?.slug === ProductsListSetup[p]?.slug) {
                                        responseProducts.push(o);
                                    }

                                })
                            }
                        }
                            for (let i = 0; i <= responseTemplate.data.products.length; i++) {
                                responseProducts.find(item => {
                                    if (item.id === responseTemplate.data.products[i]) {
                                        prod.push(item)
                                    }
                                })
                            }
                            let result = prod.filter(o1 => productsDescription.some(o2 => {
                                if (o1.slug === o2.slug) {
                                    return  o1.description = o2.description
                                }
                            }));
                            setInitialProducts(result);
                            setProductsAll(paginate(result, 1, 9));
                            setTotalPages(getPageCount(result.length, 9))
                            setProducts(paginate(result, 1, 6));
                    });
                }
            }
        }).catch(err => {
            if (err) {
                history.push('/marketplace');
            }
        })

    });

    useEffect(() => {
        fetchProducts().then();
        fetchTemplateAll().then();
    }, [templateIdFetching])

    useEffect(async () => {
        const res = await getData('/partner-requests/countries');
        const res1 = await getData('/partner-requests/countries');
        setCountryList(res1.data);
        fetchTemplateAll().then();
        fetchProducts().then();
        setFormFields([
            {
                name: 'Name',
                type: 'text',
                slug: 'fullName',
                validation: {
                    required: true,
                    min: 5,
                    max: 50,
                    regex: /[a-zA-Z0-9_s-]+$/,
                    error: 'Enter valid name'
                }
            },
            {
                name: 'Email',
                type: 'email',
                slug: 'email',
                validation: {
                    required: true,
                    regex: /^([a-z0-9_\.-]+)@([\da-z0-9\.-]+)\.([a-z\.]{2,32})$/i,
                    error: 'Enter valid E-mail'
                }
            },
            {
                name: 'Phone Number (optional)',
                type: 'phone',
                slug: 'phone.number',
                list: res.data,
                validation: {
                    required: false,
                    regex: /^[0-9]+$/i,
                    error: 'Enter valid input',
                    min: 5,
                    max: 20,
                }
            },
            {
                name: 'Type a message',
                type: 'textarea',
                slug: 'summary',
                validation: {
                    min: 5,
                    max: 1024,
                    required: true,
                    regex: /[a-zA-Z0-9,:._s-]+$/,
                    error: 'Enter valid input'
                }
            },
        ]);
    }, [])

    const markup = (str) => ({ __html: str });

    function paginate (array, pageIndex, pageSize) {
        return array.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    }

    const getImage = (slug) => {
        return require(`../../assets/imgs/productsIcon/${slug}.svg`).default;
    }

    const handleChange = (event, value) => {
        event.preventDefault();
        setProductsAll(paginate(initialProducts, value, 9));
    };

    const checkFormValidity = (e) => {
        const res = setErrorHandler(formFields, e);
        setFormFields(res);
        return new Promise((resolve) => {
            resolve(!res.find(item => item.hasError));
        })
    }

    const submitHandler = async (e) => {
        const res = await checkFormValidity(e);

        if (res) {
            const response = MarketplaceResource.postQuotation('/marketplace-request', e, template.id);
            response.then(res => {
                if (res.data) {
                    if (res.data.passed) {
                        setReset(true);
                        setModalToggle(false);
                        setShowV2(false);
                        setSuccessModal(true);
                    } else {
                        setShowV2(true);
                    }
                }
            }).catch(err => {
                toast('Ooops something went wrong!');
                setTimeout(() => {
                    history.push('/marketplace');
                }, 2000)
            })
        }
    }

  return (
    <>
        <section className="m-sp-wrapper">
            { modalToggle &&
            <div className="m-sp-modal-wrapper">
                <div className="m-sp-modal">
                    <div className="m-sp-modal-header">
                        <h2 className="m-sp-modal-heading">Ask A Quotation</h2>
                        <div className="m-sp-modal-close" onClick={(e) => {
                            e.stopPropagation();
                            setModalToggle(false);
                        }} />
                    </div>
                    <div className="m-sp-modal-content">
                        <AskQuotation formFields={formFields} showV2={showV2} reset={reset} onSubmit={submitHandler} />
                    </div>
                </div>
            </div>
            }


            { successModal &&
            <div className="m-sp-modal-wrapper">
                <div className="m-sp-modal modal-success">
                    <div className="m-sp-modal-success">
                        <div className="m-sp-modal-header">
                            <div className="m-sp-modal-close" onClick={(e) => {
                                e.stopPropagation();
                                setSuccessModal(false);
                            }} />
                        </div>
                        <div className="m-sp-modal-content">
                            <Icon class="icon-modal" icon="check-circle-icon"/>
                            <p>We have received your request and will come back to you with updates during the next 3 working days</p>
                        </div>
                    </div>
                </div>
            </div>
            }



            {
                modalProducts &&
                <div className="products-modal-body">
                    <div className="products-modal">
                        <div className="m-sp-modal-close" onClick={() => setModalProducts(false)} />
                        <h3 className="products-modal-title">products</h3>
                        <div className="products-modal-grid">

                            {
                                productsAll && productsAll.map(item => {
                                    return <article key={item.id} className="m-sp-product"
                                                onClick={(e) => {
                                                    console.log(item);
                                                    e.preventDefault();
                                                    history.push(`/products/${item.slug}`);
                                                }}
                                            >
                                        <div className="m-sp-product-heading">
                                            <img className="cardIcon"
                                                 src={getImage(item.slug)}
                                                 alt={item.name} />
                                            <h3 className="m-sp-product-title">
                                                {item.slug === 'liveMonitor' ? 'Odds Display' : item.slug === 'terminal' ? 'Self Service Betting Terminal' : item.name}
                                            </h3>
                                        </div>
                                        <p className="m-sp-product-subheading">{item.description}</p>
                                    </article>
                                })

                            }
                        </div>
                        <div className="pagination-wrapper">
                            <Pagination count={totalPages} defaultPage={1} siblingCount={2} boundaryCount={0} onChange={handleChange} shape="rounded"/>
                        </div>
                    </div>
                </div>
            }


            <div className="page-title-block">
                <div className="container-layout">
                    <div className="page-title-inner">
                        <h1 className="page-title"> {template && template.title}</h1>
                        <p className="page-title-txt">{template && template.shortDescription}</p>
                    </div>
                </div>
            </div>
            <div className="container-layout">
                <div className="m-sp-content">
                    <div className="m-sp-info-wrapper">
                        <div className="m-sp-product-preview">
                            <div className="m-sp-product-preview-img">
                                <img src={`${REACT_APP_IMAGE_URL}` + template?.file.path} alt=""/>
                            </div>
                            <div className="m-sp-product-preview-info">
                                <p className="m-sp-product-preview-txt">
                                    <b className="m-sp-product-preview-title">All-in-One Ready-to-Operate Business</b>
                                    We, at BetConstruct, allow you to benefit from an iGaming platform already designed for your specific market and your player niche.
                                    Everything, from a ready-to-use online platform to an active payment gateway is yours right away. You don’t have to be tech-savvy, spending precious time trying to connect all the puzzle pieces with each other. We already did all of that for you and it’s set to go.
                                    Getting your business up and running has never been easier or faster. Get yours today.
                                </p>

                                <div className="m-sp-product-preview-buttons">
                                    <button className="stroked " type="button" onClick={() => window.open(template.previewLink, '_blank')}>Preview</button>
                                    <button className="filled " type="button" onClick={ () => setModalToggle(true) }>Ask A Quotation</button>
                                </div>
                            </div>
                        </div>

                        <div className="m-sp-product-desc-wrapper">
                            <h2 className="m-sp-heading">Description</h2>
                            { template && <div className="m-sp-product-desc-content" dangerouslySetInnerHTML={markup(template.description)} /> }
                        </div>
                    </div>

                    {products?.length ?
                      <div className="m-sp-products">
                          <div className="m-sp-products-header">
                              <h2 className="m-sp-heading">Products</h2>
                              <button className="m-sp-button" type="button" onClick={() => setModalProducts(true)}>
                                  <span>See All</span></button>
                          </div>


                          <div className="m-sp-products-list">
                              {
                                  products && products.map(item => {
                                      return <article key={item.id} className="m-sp-product"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        history.push(`/products/${item.slug}`);
                                                      }}
                                      >
                                          <div className="m-sp-product-heading">
                                              <img className="cardIcon"
                                                   src={getImage(item?.slug)}
                                                   alt={item?.name}/>
                                              <h3 className="m-sp-product-title">
                                                  {item.slug === 'liveMonitor' ? 'Odds Display' : item.slug === 'terminal' ? 'Self Service Betting Terminal' : item.name}
                                              </h3>
                                          </div>
                                          <p className="m-sp-product-subheading">{item.description}</p>
                                      </article>
                                  })

                              }
                          </div>


                      </div> : null
                    }
                </div>
            </div>

            {
                (similar?.length >= 3) ?
                  <div className="m-sp-templates">
                      <div className="container-layout">
                          <div className="m-sp-section-title-block">
                              <h2 className="m-sp-section-title">Explore More Templates</h2>
                              <p className="m-sp-section-subtitle">With a plethora of professional iGaming templates, designs, and
                                  quality content to choose from, get a headstart on customizing your business.</p>
                          </div>

                          <div className="marketplace-content-holder">
                              {
                                  similar && similar.map((item, idx) => {
                                      return <div key={idx} className="marketplace-content-item">
                                          <div className="marketplace-item-img">
                                              <img
                                                src={`${REACT_APP_IMAGE_URL}` + item.file.path}
                                                alt={item.title}/>
                                          </div>
                                          <div className="marketplace-item-info">
                                              <p className="marketplace-item-info-title">{item.title}</p>
                                              <p className="marketplace-item-info-text">{item.shortDescription}</p>
                                              <div className="marketplace-item-info-btn-inner">
                                                  <div className="btn-wrapper">
                                                      <button className="stroked green" type="button" onClick={() => window.open(item.previewLink, '_blank')}>Preview</button>
                                                  </div>
                                                  <div className="btn-wrapper">
                                                      <button className="filled " type="button" onClick={(e) => {
                                                          e.preventDefault();
                                                          history.push(`/marketplace/${item.id}`);
                                                          setTemplateIdFetching(item.id);
                                                          window.scrollTo({
                                                              top: 0,
                                                              behavior: 'smooth'
                                                          });
                                                      }}>Learn More</button>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  })
                              }
                          </div>
                      </div>
                  </div> : null
            }

        </section>
        <ToastContainer hideProgressBar />
    </>
  );
};

export default MarketplaceSinglePage;
